export type ModeType = 'READ' | 'ACTIVE';
export interface VisitMetaData {
    id: number;
    requestId?: string;
    reviewerId?: string;
    role: RolesEnum;
    visitId?: number;
    visitKey?: string;
    generatedId?: string;
    memberId?: string;
    mode: ModeType;
    accreditationKey?: string;
    eligibilityRequestId?: string;
    isMasar?: boolean;
    sessionChecked: SessionChecked;
}

export interface SessionChecked {
    sessionStarted?: boolean;
}

export enum RolesEnum {
    REVIEWER = 'REVIEWER',
    TEAM_LEADER = 'TEAM_LEADER',
    MEMBER = 'MEMBER',
}
